import { useEffect, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import storage from '@/utils/storage';
import { checkModalOrDrawerVisible } from '@/utils/dom';
import {
  FUNCTION_SHORTCUT_KEYS,
  handleMenuAuth,
} from '@/components/SystermSettingsModal/components/QuickKey/helper';
import { getShortcutConfig } from '@/api/setting';
import actionTypes from '@/redux/actions/user/actionType';

export const useShortcuts = ({
  handleRoomCard,
  handleNewCard,
  handleInvite,
  handleHandover,
  handleReservePortal,
  handleCheckInPortal,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isGroupPage = storage.get('isGroupLogin');
  const { menus, companyGroup, shortcuts } = useSelector((e: any) => e.user);

  // 注册快捷键事件
  useEffect(() => {
    if (
      (menus && menus.length > 0) ||
      (companyGroup && companyGroup.menus && companyGroup.menus.length > 0)
    ) {
      getShortcutConfig().then((res: any) => {
        if (res.code === 0) {
          const {
            menuShortcuts,
            funcShortcuts,
            groupShortcuts,
            storePageEntry,
            groupPageEntry,
          } = res.data || {
            menuShortcuts: [],
            funcShortcuts: [],
            groupShortcuts: [],
            storePageEntry: [],
            groupPageEntry: [],
          };

          dispatch({
            type: actionTypes.UPDATE_SHORTCUT_CONFIG,
            payload: {
              menuShortcuts: isGroupPage ? menuShortcuts : handleMenuAuth(menuShortcuts, menus),
              funcShortcuts,
              groupShortcuts: handleMenuAuth(groupShortcuts, companyGroup?.menus || []),
              storePageEntry: isGroupPage
                ? storePageEntry
                : handleMenuAuth(storePageEntry, menus || []),
              groupPageEntry: handleMenuAuth(groupPageEntry, companyGroup?.menus || []),
            },
          });
        }
      });
    }
  }, [companyGroup, menus, dispatch]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // 获取当前按下的快捷键
      let pressedKey = '';
      const allowKeys = [...FUNCTION_SHORTCUT_KEYS];
      console.log(event);
      // 增加esc退出全屏
      if (event.altKey) {
        const numberMatch =
          event.code.match(/^Digit([0-9])$/) || event.code.match(/^Numpad([0-9])$/);
        if (numberMatch) {
          pressedKey = `Alt+${numberMatch[1]}`;
        }
      } else if (/^F(1|2|3|4|6|7|8|9|10)$/.test(event.key)) {
        pressedKey = event.key;
      } else if (window.electron && event.key === 'F11') {
        pressedKey = 'F11';
      } else if (window.electron && event.key === 'F5') {
        pressedKey = 'F5';
      } else if (event.key === 'Escape') {
        pressedKey = 'Escape';
      }
      console.log(pressedKey, 'pressedKey');
      if (window.electron) {
        allowKeys.push('F11', 'F5', 'Escape');
      }
      // 我们定义的key  阻止默认事件
      if (allowKeys.includes(pressedKey)) {
        // 阻止浏览器默认行为 当前快捷键
        event.preventDefault();
      }
      // 如果不是我们定义的快捷键，不处理
      if (!pressedKey || !allowKeys.includes(pressedKey)) {
        return;
      }
      // 如果有弹窗或抽屉打开，不处理快捷键
      if (checkModalOrDrawerVisible() || !shortcuts) {
        return;
      }
      if (window.electron && pressedKey === 'F11') {
        const fullScreenFlag = JSON.parse(storage.get('fullScreenFlag'));
        storage.set('fullScreenFlag', !fullScreenFlag);
        window.electron?.ipcRenderer.screenResize(
          !fullScreenFlag ? 'full-screen' : 'full-screen-Exit',
        );
        return;
      }
      if (window.electron && pressedKey === 'F5') {
        window?.location.reload();
        return;
      }
      if (window.electron && pressedKey === 'Escape') {
        // 退出全屏
        storage.set('fullScreenFlag', false);
        window.electron?.ipcRenderer.screenResize('full-screen-Exit');
        return;
      }
      if (isGroupPage) {
        // 集团快捷键生效
        const matchedMenu = shortcuts.groupShortcuts.find((item) => item.key === pressedKey);
        if (matchedMenu?.path) {
          history.push(matchedMenu.path);
        }
      } else {
        // 门店快捷键生效
        const matchedFunc = [...shortcuts.funcShortcuts, ...shortcuts.menuShortcuts].find(
          (item) => item.key === pressedKey,
        );
        // 如果快捷键没有匹配到，不处理
        if (!matchedFunc) {
          return;
        }
        if (matchedFunc?.func) {
          // 门店功能快捷键
          switch (matchedFunc.func) {
            case 'newReservation': // 新预订
              handleReservePortal();
              break;
            case 'newCheckIn': // 新入住
              handleCheckInPortal();
              break;
            case 'newMemberCard': // 新办会员卡
              handleNewCard();
              break;
            case 'centralReservation': //  中央预订邀请单
              handleInvite();
              break;
            case 'readRoomCard': //  读房卡
              handleRoomCard();
              break;
            case 'handover': //  交班;
              handleHandover();
              break;
            default:
              break;
          }
        } else {
          history.push(matchedFunc.path);
        }
      }
    };
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [shortcuts, isGroupPage, history]);

  // 初始化设置全屏
  useEffect(() => {
    const fullScreenFlag = JSON.parse(storage.get('fullScreenFlag'));
    storage.set('fullScreenFlag', fullScreenFlag);
    window.electron?.ipcRenderer.screenResize(fullScreenFlag ? 'full-screen' : 'full-screen-Exit');
  }, []);
};
